import { render, staticRenderFns } from "./AgreementInfo.vue?vue&type=template&id=45991c97"
import script from "./AgreementInfo.vue?vue&type=script&lang=js"
export * from "./AgreementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports